import { ErrorPage } from '@/components/common/ErrorPage'

/** Страница «Страница не найдена» (404) для неизвестных маршрутов. */
export function NotFoundPage() {
  return <ErrorPage statusCode={404} fullPage />
}
